export async function getConfig() {
  const response = await fetch('/config.json', {
    cache: "reload",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  const appConfig = await response.json();
  localStorage.setItem('Config', JSON.stringify(appConfig));

  return appConfig;
}
